<template>
  <div class="featured-games-wrapper p-2">
    <div class="row">
      <div class="col-12">
        <div class="featured-games-header">
          <h5>Popular</h5>
        </div>
      </div>
      <div class="col-12">
        <div class="featuredgames-tab-container">
          <div class="featuredgames-tab">
            <button
                v-for="game in gameTypes"
                :key="game.name"
                @click="changeTab(game.name)"
                :class="{ active: currentTab === game.name }"
                class="tablinks"
            >
              <span class="link-wrap">
                <span class="link-icon">
                  <img :src="game.icon" :alt="`${game.name} image`" />
                </span>
                <span class="link-text">{{ game.name }}</span>
              </span>
            </button>
          </div>
        </div>

        <div class="featuredgames-content-wrapper">
<!--          <div v-if="loading">-->
<!--            <ShimmerSCasino />-->
<!--          </div>-->
          <div class="featuredgames-content">
            <div class="popular-games-wrapper">
              <div class="popular-games-wrap">
                <div class="popular-games-container">
                  <div
                      class="popular-game"
                      v-if="currentTab === 'Popular'"
                      v-for="game in currentGames"
                      :key="game.game_id"
                  >
                    <div class="popular-sport">
                      <div class="game-playing">
                        <div class="card">
                          <div class="leaguetype-and-time">
                            <span class="country-league-wrap">
                              <span class="country-league">{{ getAbbrevs(game.country) }}</span>
                              <span class="leaguetype-wrap">{{ getAbbrevs(game.tournament) }}</span>
                            </span>
                            <span class="date-playing-and-time-playing">
                              {{ formatDateTime(game.date) }}
                            </span>
                          </div>

                          <div class="teams-playing-and-market-selection">
                            <div class="teams-playing-wrap d-flex">
                              <div class="team-playing home-team">{{ getAbbrevs(game.home_team) }}</div>
                              <div class="verses">-</div>
                              <div class="team-playing away-team">{{ getAbbrevs(game.away_team) }}</div>
                            </div>

                            <div class="market-selection-wrap">
                              <div
                                  class="market-selection"
                                  v-for="outcome in game.highlight_market.outcomes"
                                  :key="outcome.outcome_id"
                              >
                                <span :class="['small', 'select-market', getTeamClass(outcome.alias)]">
                                  <Odd
                                      :date="game.date"
                                      :match_id="game.match_id"
                                      :market_name="game.highlight_market.market_name"
                                      :market_id="game.highlight_market.market_id"
                                      :market_status="game.highlight_market.status"
                                      :specifier="game.highlight_market.specifier"
                                      :home_team="game.home_team"
                                      :away_team="game.away_team"
                                      :pick="outcome"
                                      :producer_id="game.producer_id"
                                      :producer_status="game.producer_status"
                                      :status="game.status"
                                      :status_name="game.highlight_market.status_name"
                                      :game_id="game.game_id"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      class="popular-game"
                      v-else
                      v-for="game in currentGames"
                      :key="game.id"
                  >
                    <a href="#" @click.prevent="playGame(game, game.launchType)">
                      <img
                          :src="game.image"
                          :alt="`${game.name} image`"
                          @error="setFallbackImage($event, game)"
                          :class="{ 'fallback-image': !isImageAccessible }"
                      />
                      <div class="popular-games-overlay" v-show="!isImageAccessible">
                        <div class="card-footer">
                          <div class="display-name">
                            <div class="featured-game-name" style="font-size: 9px">
                              {{ game.name }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  </div>
                </div>
              </div>
            </div>
          <!-- End content wrapper -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCasinoStore } from '@/stores/casino.js';
import { useGameStore } from '@/stores/games.js';
import dayjs from 'dayjs';
import Odd from '@/components/Odd.vue';
import ShimmerSCasino from '@/components/shimmer/ShimmerSmallCasino.vue';

export default {
  name: 'FeaturedGamesNav',
  components: { Odd, ShimmerSCasino },
  data() {
    return {
      isImageAccessible: false,
      // loading: true,
      gameTypes: [
        {
          name: 'Crash',
          icon: '/assets/images/backup/yellowdice-new2.webp',
        },
        // {
        //   name: 'Win Boost',
        //   icon: 'https://storage.googleapis.com/maybet/site/assets/lightning.png',
        // },
        {
          name: 'Casino',
          icon: '/assets/images/backup/icon_casino2.png',
        },
        {
          name: 'Instant',
          icon: '/assets/images/backup/instant2.png',
        },
        {
          name: 'Virtuals',
          icon: '/assets/images/backup/icon-virtual2.png',
        },
        {
          name: 'Quick Wheels',
          icon: '/assets/images/backup/icon_spin2win2.svg',
        },
      ],
      currentTab: 'Crash',
      userCounts: {},
      winners: {},
      sampleUsers: [
        'A***i', 'B***e', 'C***o', 'D***n', 'E***r', 'F***a', 'G***i', 'H***o', 'I***u', 'J***e',
        'K***a', 'L***i', 'M***o', 'N***e', 'O***i', 'P***a', 'Q***e', 'R***o', 'S***a', 'T***u',
        'U***y', 'V***i', 'W***e', 'X***o', 'Y***i', 'Z***n', 'Al**', 'Bo**', 'Ev**', 'Su**', 'To**',
        'Ja**', 'Le**', 'Ma**', 'Zo**', 'Ra**', 'An**', 'Ad**', 'Sa**', 'Lo**', 'Mi**', 'Jo**', 'Am**',
        'Be**', '254***12**', '254***56**', '254***91**', '254***11**', '254***31**', '254***51**', '254***71**', '254***92**',
        '254***12**', '254***32**', '254***52**', '254***72**', '254***93**', '254***13**', '254***33**', '254***53**',
        '254***73**', '254***94**', '254***14**', '254***34**', '254***54**', '254***74**', '254***95**', '254***15**',
        '254***35**', '254***55**', '254***75**', '254***96**', '254***16**', '254***36**', '254***56**', '254***76**',
        '254***97**', '254***17**', '254***37**', '254***57**', '254***78**', '254***98**', '254***18**', '254***38**',
        '254***58**', '254***79**', '254***99**', '254***19**', '254***39**', '254***59**', '254***80**', '254***90**',
        '254***20**', '254***40**', '254***60**', '254***81**', '254***91**', '254***21**', '254***41**', '254***61**'
      ],
      abbrevs: {
        'International Clubs': "Int'nl Clubs",
        'United States': 'USA',
        "UEFA Champions League": 'UCL'
      }
    };
  },
  computed: {
    currentGames() {
      const store = useGameStore();
      switch (this.currentTab) {
        case 'Crash':
          return store.crashGames;
        case 'Casino':
          return store.casinoGames;
        case 'Instant':
          return store.instantGames;
        case 'Virtuals':
          return store.virtualsGames;
        case 'Quick Wheels':
          return store.quickWheelsGames;
        case 'Popular':
          return store.boosted;
        default:
          return [];
      }
    },
  },
  methods: {
    changeTab(gameName) {
      this.currentTab = gameName;
      this.initSlider();
    },
    checkImageAvailability(imageUrl) {
      const image = new Image();
      image.src = imageUrl;
      image.onload = () => {
        this.isImageAccessible = true;
      };
      image.onerror = () => {
        this.isImageAccessible = false;
      };
    },
    setFallbackImage(event, game) {
      this.isImageAccessible = false;
      event.target.src = '/assets/images/backup/casinholder.png';
    },
    playGame(game, launchType) {
      if (!game || !game.id) {
        console.error('Invalid game object:', game);
        return;
      }

      if (game.name === "Ligi Soo") {
        window.location.href = "https://maybets.com/ligisoo";
        return;
      }

      let params = {
        gameID: game.id,
        gameName: game.name,
        launchType: launchType,
        providerId: game.providerId,
        launchUrl: ``
      };

      useCasinoStore().setLaunchGame(params);
      this.$router.push({ name: 'casinogames' });
    },
    getUserCount(gameId) {
      return this.userCounts[gameId] || 0;
    },
    getWinners(gameId) {
      return this.winners[gameId] || [];
    },
    updateUserCounts() {
      const now = new Date();
      const hour = now.getHours();
      const isDayTime = hour >= 6 && hour < 18;

      this.currentGames.forEach(game => {
        if (game.name === 'Aviator') {
          this.userCounts[game.id] = isDayTime
              ? Math.floor(Math.random() * (18000 - 10000 + 1)) + 10000
              : Math.floor(Math.random() * (30000 - 20000 + 1)) + 20000;
        } else {
          this.userCounts[game.id] = Math.floor(Math.random() * 10000) + 1000;
        }
      });
    },
    updateWinners() {
      this.currentGames.forEach(game => {
        const sampleWinners = [];
        for (let i = 0; i < 20; i++) {
          sampleWinners.push({
            id: `${game.id}-${i}`,
            name: this.sampleUsers[Math.floor(Math.random() * this.sampleUsers.length)],
            amount: Math.floor(Math.random() * (10000 - 5000 + 1)) + 5000,
          });
        }
        this.winners[game.id] = sampleWinners;
      });
    },
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    initSlider() {
      this.$nextTick(() => {
        const sliders = document.querySelectorAll('.notification-slider');
        sliders.forEach(slider => {
          let idx = 0;
          setInterval(() => {
            const items = slider.children;
            if (items.length) {
              items[idx].classList.remove('active');
              idx = (idx + 1) % items.length;
              items[idx].classList.add('active');
            }
          }, 3000);
        });

        sliders.forEach(slider => {
          slider.addEventListener('touchstart', this.debounce(() => {
            slider.style.overflowY = 'hidden';
          }, 100));
          slider.addEventListener('touchend', this.debounce(() => {
            slider.style.overflowY = 'auto';
          }, 100));
        });
      });
    },
    formatDateTime(dateTimeString) {
      return dayjs(dateTimeString).format('DD/MM, HH:mm');
    },
    getTeamClass(alias) {
      if (alias === '1') return 'home-team';
      if (alias === 'X') return 'draw-team';
      if (alias === '2') return 'away-team';
      return '';
    },
    getAbbrevs(name) {
      return this.abbrevs[name] || name;
    }
  },
  async mounted() {
    this.checkImageAvailability('https://storage.googleapis.com/maybet/site/freebet/FREEBETCAROUSEL.jpg');
    const store = useGameStore();
    await store.initializeLimitedGames();
    await store.fetchBoostedGames();

    this.updateUserCounts();
    this.updateWinners();
    this.initSlider();

    // this.loading = false;

    setInterval(() => {
      this.updateUserCounts();
      this.updateWinners();
      this.initSlider();
    }, 5000);
  },
};
</script>

<style scoped>
.featured-games-wrapper {
  overflow-x: hidden;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.featuredgames-tab-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.featuredgames-tab {
  display: flex;
  flex-wrap: nowrap;
}

.tablinks {
  flex: 1 0 auto;
  white-space: nowrap;
}

.featuredgames-content-wrapper {
  overflow-x: hidden;
  width: 100%;
}

.featuredgames-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.popular-games-wrapper {
  overflow-x: hidden;
  width: 100%;
}

.popular-games-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  scroll-behavior: smooth;
}

.popular-games-container {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.notification-slider {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 14px;
}

.notification {
  display: none;
}

.notification-slider .notification:first-child {
  display: block;
}

@media (max-width: 768px) {
  .popular-game {
    width: calc(100% / 2 - 10px);
  }
}

@media (max-width: 480px) {
  .popular-game {
    width: calc(100% - 10px);
  }
}
</style>